export default __webpack_public_path__ + "static/middleware@2x-006d8585dd2fe4187d2e2600ba1858f8.png";